import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  resources: {
    en: {
      translations: require("./locals/en/translations.json"),
    },
    it: {
      translations: require("./locals/it/translations.json"),
    },
    fr: {
      translations: require("./locals/fr/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en", "it", "fr"];

i18n.supportedLanguages = ["en", "it", "fr"];

export default i18n;
